module.exports = __webpack_public_path__ + "static/media/check.e54e6aaf.svg";